<!-- 
Shows action buttons and tabs for the scheduled job page.
-->
<template>
  <div>
    <our-actions-bar 
      :actions="actions"
      @edit="showEditDialog=true" 
      @run="showRunDialog=true" 
      @delete="showDeleteDialog=true"
    />
    <v-card class="home">
      <v-tabs slider-color="primary" show-arrows>
        <v-tab key="summary" :to="getUrl('summary')">
          Summary
        </v-tab>
        <v-tab key="history" :to="getUrl('history')">
          History
        </v-tab>
      </v-tabs>
      <slot/>
    </v-card>
    <scheduled-job-edit-dialog 
      v-model="showEditDialog"
      :scheduled-job-id="scheduledJobId" 
      :create="false"      
    />
    <scheduled-job-delete-dialog 
      v-model="showDeleteDialog"
      :scheduled-job-id="scheduledJobId"
      @changed="$router.push('/scheduled-jobs')"
    />
    <scheduled-job-run-dialog 
      v-model="showRunDialog"
      :scheduled-job-id="scheduledJobId" 
      :description="description" 
    />
  </div>
</template>

<script>
import ScheduledJobEditDialog from "@/components/scheduled-jobs/ScheduledJobEditDialog.vue";
import ScheduledJobDeleteDialog from "@/components/scheduled-jobs/ScheduledJobDeleteDialog.vue";
import ScheduledJobRunDialog from "@/components/scheduled-jobs/ScheduledJobRunDialog.vue";
import * as claim from "@/store/claim-types";

export default {
  components: { ScheduledJobEditDialog, ScheduledJobDeleteDialog, ScheduledJobRunDialog },
  props: {
    scheduledJobId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showEditDialog: false,
      showDeleteDialog: false,
      showRunDialog: false
    };
  },
  computed: {
    actions() {
      return this.canEdit
        ? [
            { icon: "play_arrow", text: "Run", description: "Run this job now.", emit: "run" },
            { icon: "edit", text: "Edit", description: "Edit the settings for this scheduled job.", emit: "edit" },
            { icon: "delete", text: "Delete", description: "Delete this scheduled job.", emit: "delete" }
          ]
        : [];
    },
    canEdit() {
      return this.$store.getters.claims.includes(claim.SCHEDULED_JOBS_EDIT);
    },
    description() {
      return this.$store.state.lookups.data.jobTypeDescriptions[this.$store.state.scheduledJobs.view.data.type];
    }
  },
  methods: {
    getUrl(suffix) {
      return `/scheduled-jobs/${this.scheduledJobId}/${suffix}`;
    }
  }
};
</script>
